import React from "react";
import { MdEmail, MdBadge } from "react-icons/md";
import Avatar from "components/avatar";
import Card, { CardHeader } from "components/card";

const ProfileCard = ({ user }) => {
  if (!user) return null;

  const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim() || "User";

  const roleLabel = user.role
    ? user.role.charAt(0).toUpperCase() + user.role.slice(1).replace(/_/g, " ")
    : "Member";

  return (
    <Card padding="md" className="gap-4">
      <CardHeader title="My Profile" />
      <div className="flex items-center gap-4">
        <Avatar user={user} size="md" className="shrink-0" />
        <div className="min-w-0">
          <p className="truncate text-base font-bold text-fg">{fullName}</p>
          <p className="mt-0.5 flex items-center gap-1.5 text-sm text-fg-muted">
            <MdBadge aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
            <span>{roleLabel}</span>
          </p>
          {user.email && (
            <p className="mt-0.5 flex items-center gap-1.5 text-sm text-fg-muted">
              <MdEmail aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{user.email}</span>
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default ProfileCard;
